export default class TokenHandler {
    constructor($window) {
        this._window = $window;
        this.token = false;
    }

    set(newToken) {
        this.token = newToken;
        localStorage.setItem('token', this.token);
    }

    getToken() {
        return localStorage.getItem('token');
    };

    remove() {
        const token = this.getToken();

        if (token) {
            localStorage.removeItem('token');
        }
    };
};

TokenHandler.$inject = ['$window'];
